module.exports = __webpack_public_path__ + "static/media/dr-venus.ef2cd1e5.png";